import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  ExtractedData,
  extractedDataToObjects,
  ExtractedObject,
} from '../../types'
import { flow, pipe } from 'fp-ts/lib/function'
import { Table, Button, Card } from 'antd'
import { record, array, string } from 'fp-ts'
import { ColumnType } from 'antd/lib/table'
import { FormattedMessage } from 'react-intl'
import { selectSheetAction, stepForwardAction, stepBackAction } from './types'
import styled from 'styled-components'
import { useMode } from '../Bills/queries'

const useSelectState = () => {
  const upload = useSelector(s => s.upload)
  return upload.state === 'Select' ? upload : undefined
}

const Sheet = ({ sheet }: { sheet: ExtractedData }) => {
  const data = pipe(sheet, extractedDataToObjects, array.takeLeft(1))

  return (
    <Table
      size="small"
      dataSource={data.map((v, i) => ({ ...v, key: i }))}
      columns={pipe(
        record.keys(sheet),
        array.map(
          (name): ColumnType<ExtractedObject> => ({
            title: name,
            dataIndex: name,
            onCell: () => ({
              style: { textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
            }),
          })
        )
      )}
      pagination={false}
      scroll={{ x: true }}
    />
  )
}

const ButtonRow = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
`

const SelectableCard = styled(Card)<{ selected: boolean }>`
  cursor: pointer;
  border-color: ${p => (p.selected ? p.theme.colors.primary : '')};
  margin-bottom: ${p => p.theme.paddingUnit}px;
  :hover {
    box-shadow: 0 0 0 4px rgba(0, 158, 15, 0.2);
  }
`

const SelectSheets = () => {
  const mode = useMode()
  const upload = useSelectState()
  const data = upload?.data ?? {}
  const selected = upload?.selectedSheets ?? []
  const dispatch = useDispatch()

  return (
    <>
      {pipe(
        data,
        record.collect((name, points) => (
          <SelectableCard
            selected={array.elem(string.Eq)(name, selected)}
            title={name}
            onClick={() => dispatch(selectSheetAction(name))}
          >
            <Sheet sheet={points} />
          </SelectableCard>
        ))
      )}
      <ButtonRow>
        <Button.Group>
          <Button onClick={flow(stepBackAction, dispatch)}>
            <FormattedMessage id="back" />
          </Button>
          <Button
            disabled={selected.length === 0}
            onClick={() => dispatch(stepForwardAction(mode))}
            type="primary"
          >
            <FormattedMessage id="next" />
          </Button>
        </Button.Group>
      </ButtonRow>
    </>
  )
}

export default SelectSheets
